export default __webpack_public_path__ + "static/flat-132ec3f9a250d529a768c232a38ea799.png";